<!-- Somente leitura (parceiro, card 3307): quem autoriza é o endpoint do deal, não o DFP_VIEW. -->
@if (readOnly() || canViewDfp()) {
  <section class="dfp-historical" [class.dfp-historical--embedded]="embedded()">
    <!-- Embutida (aba do deal, card 3268): a empresa é a do deal, então sem título e sem seletor. -->
    @if (!embedded()) {
      <header class="dfp-historical__header ignore-export">
        <h1 class="dfp-historical__header__title">DFP Histórica</h1>
      </header>
    }

    <div class="dfp-historical__filters ignore-export">
      @if (!embedded()) {
        <div class="dfp-historical__filters__company">
          <app-select-company
            class="company-select"
            [allowEmptyPlaceholderSelect]="true"
            [formGroup]="filtersForm"
            [controlName]="'companyId'"
            [placeholder]="tk.Management.Company | t"
            (click)="initialTour.handleOutsideClick($event)" />
        </div>
      }

      <!-- AV, escala, comparar e exportar são das abas de demonstrativos; a aba IR dos sócios tem os seus controles. -->
      @if (hasTableData && !tabs.is('partner-income-tax')) {
        <div class="dfp-historical__filters__view" [formGroup]="chooseAnalysisColumns">
          <span class="dfp-historical__filters__view__label">Visualizar</span>
          @for (checkbox of analysisColumns; track checkbox.value) {
            <app-checkbox
              [checkbox]="checkbox"
              [hasSelectionHighlight]="false"
              [highlight]="false"
              (sendCheckedChange)="handleCheckedChange($event)" />
          }
        </div>
      }

      @if (hasTableData && !tabs.is('partner-income-tax')) {
        <!--
        Escala de exibição dos valores. Fica junto do "Visualizar" porque é a mesma natureza de controle:
        muda como a tela mostra o que já está carregado, sem ir ao servidor. Mesmo gate `hasTableData` do
        bloco de AV — sem tabela na tela não há valor a escalar.
      -->
        <div class="dfp-historical__filters__scale">
          <span class="dfp-historical__filters__scale__label">Escala</span>
          <app-select
            class="scale-select"
            [options]="valueScaleOptions"
            [ngModel]="valueScale"
            (ngModelChange)="onValueScaleChange($event)" />
        </div>
      }

      @if (hasTableData && !readOnly() && !tabs.is('partner-income-tax')) {
        <!-- Comparação visão Legatus × Visão Cliente (card 3614): o botão e a janela vivem no componente. -->
        <app-statement-comparison
          class="dfp-historical__filters__compare"
          [companyId]="selectedCompanyId"
          [companyName]="getSelectedCompanyName()"
          [sourceDocuments]="sourceDocuments"
          [valueScale]="valueScale"
          [showAnalysisColumns]="showAnalysisColumns"
          [incomeData]="incomeStatementTableData"
          [balanceData]="balanceSheetTableData" />
      }

      <!-- Escondido com [hidden], não @if: o `forceExportButtonNativeTitle` procura o botão uma vez, no init. -->
      @if (!readOnly()) {
        <div class="dfp-historical__filters__export" [hidden]="tabs.is('partner-income-tax')">
          <app-button
            icon="pi pi-download"
            [pureIcon]="true"
            [outlined]="true"
            title="Exportar"
            (sendClick)="exportMenu.toggle($event)" />
          <p-menu #exportMenu [popup]="true" [model]="exportMenuItems" [appendTo]="'body'" />
        </div>
      }
    </div>

    <!--
    Abas (card 3515), abaixo do seletor de empresa. A aba vai no `?tab=` (fora do modo embutido). IR dos sócios
    só com PARTNERINCOMETAX_VIEW e nunca no modo somente leitura (ver `DfpTabsState`).
  -->
    <!--
    Barra "Mostrar" (card 3801) na mesma linha das abas, à direita, para não gastar uma linha a mais (Victor,
    30/10/2026). Só na aba Resumo e só com números na tela; o estado vazio não tem o que ligar. Na aba Demonstrativos
    (PBI 3875, antes uma aba por demonstrativo, card 3824) o mesmo lugar tem o seletor Balanço | DRE | Faturamento: o
    demonstrativo escolhido inteiro, sem a barra.
  -->
    <div class="dfp-historical__tabbar">
      <app-tab-view
        class="dfp-historical__tabs ignore-export"
        theme="line"
        [tabViewItems]="tabs.items()"
        [tabIndex]="tabs.activeIndex()"
        (sendTabViewActiveIndex)="tabs.selectIndex($event)" />
      @if (hasDemands && hasTableData && !hasNoValidatedData) {
        @if (tabs.is('statements')) {
          <app-dfp-module-toggles class="dfp-historical__tabbar-toggles" />
        } @else if (tabs.is('financial-statements')) {
          <!-- Expandir/recolher todos os demonstrativos de uma vez (pedido do Victor, 03/11/2026). -->
          <div class="dfp-historical__tabbar-toggles statement-collapse-actions">
            <app-button
              label="Expandir todos"
              icon="pi pi-angle-double-down"
              theme="white"
              size="small"
              (sendClick)="tabs.setAllCollapsed(false)" />
            <app-button
              label="Recolher todos"
              icon="pi pi-angle-double-up"
              theme="white"
              size="small"
              (sendClick)="tabs.setAllCollapsed(true)" />
          </div>
        }
      }
    </div>

    <!--
    Score de crédito (card 3766): faixa compacta com a nota calculada dos demonstrativos validados desta tela.
    Mesmo gate das tabelas (hasTableData); fica fora do modo parceiro (readOnly) e da tela embutida no deal,
    e exige a permissão própria CREDITSCORE_VIEW_COMPANY. Abaixo das abas e escondida na aba IR dos sócios,
    que não mostra os demonstrativos (card 3515).
  -->
    <!-- Faixa do score e aviso de documentos num bloco só: espaço entre os dois e o mesmo recuo dos cards das
    abas, para alinhar pela mesma borda (Victor, 28/10/2026, card 3515). -->
    <div class="dfp-historical__context">
      @if (
        selectedCompanyId &&
        hasTableData &&
        !readOnly() &&
        !embedded() &&
        canViewCreditScore() &&
        !tabs.is('partner-income-tax')
      ) {
        <app-credit-score-strip [companyId]="selectedCompanyId" />
      }

      <!--
      Aviso de documentos contábeis em processamento: só com números na tela (o estado vazio já fala da
      padronização em andamento) e fora do modo somente leitura (a lista da Padronização é do time interno).
      Fica nas abas de demonstrativos; a aba IR dos sócios avisa das próprias leituras.
    -->
      @if (
        selectedCompanyId &&
        !readOnly() &&
        hasDemands &&
        !hasNoValidatedData &&
        !statementsPending()
      ) {
        <div [hidden]="tabs.is('partner-income-tax')">
          <app-dfp-processing-documents-notice
            [companyId]="selectedCompanyId"
            (processingSetChanged)="onProcessingSetChanged()" />
        </div>
      }
    </div>

    <!--
    "Selecione uma empresa" só depois de a lista de empresas voltar sem empresa resolvida: a empresa da URL ou do
    store é aplicada antes, e até a lista chegar a tela mostra o carregando, não um estado que não é o real.
  -->
    @if (!selectedCompanyId && companiesLoaded) {
      <app-simple-messages [text]="tk.General.StartModelingSelectCompany | t" severity="info" />
    } @else if (!selectedCompanyId) {
      <div class="dfp-historical__company-loading">
        <app-cog-loading-spinner [size]="48" />
      </div>
    }

    @if (selectedCompanyId && tabs.is('partner-income-tax')) {
      <app-partner-income-tax />
    }

    <!--
    Os quatro módulos (DRE, Balanço, Pontos de destaque, Faturamento) ficam no DOM o tempo todo e somem por [hidden],
    seja pela aba IR dos sócios, seja pelo interruptor da barra "Mostrar" (card 3801): a exportação Excel lê as tabelas
    do DOM (`DfpExportService`) e precisa das quatro.
  -->
    <div class="dfp-historical__statements" [hidden]="tabs.is('partner-income-tax')">
      <!--
    Estado vazio: empresa escolhida, carga concluída e nada para exibir — ou o `/dfp/status` sequer pôde ser
    lido (`hasDemands === false`). As redações, o polling da padronização e os atalhos vivem no componente;
    aqui fica só a condição de exibir.
  -->
      @if (selectedCompanyId && !isLoading && (hasNoValidatedData || !hasDemands)) {
        @if (readOnly()) {
          <!-- O estado vazio completo leva para a Padronização, que é do time interno. -->
          <app-simple-messages
            text="Ainda não há demonstrativos desta empresa para mostrar. A análise aparece aqui quando a Legatus concluir a leitura dos documentos."
            severity="info" />
        } @else {
          <app-dfp-empty-state
            [companyId]="selectedCompanyId"
            [statusUnavailable]="!hasDemands"
            (standardizationFinished)="handleLoadPage()" />
        }
      }

      <ng-container *ngIf="!!hasDemands">
        <div class="dfp-historical__content mt-3">
          <!-- Tudo desligado na barra "Mostrar": estado vazio com os atalhos (os módulos seguem no DOM, escondidos). -->
          @if (modules.isEmpty() && hasTableData && !hasNoValidatedData) {
            <app-dfp-modules-empty-state />
          }

          <!--
          Grade em alvenaria (`appStatementMasonry`): na ordem em que a pessoa ligou, duas colunas; o módulo seguinte
          entra embaixo da coluna mais curta quando ela sobra (ex.: Faturamento embaixo da DRE, ao lado do Balanço).
          A borda direita dos cards da esquerda arrasta para redimensionar as colunas, como coluna de tabela
          (`app-statement-resizer`); a divisão fica salva no navegador. Classes e ids `statement-*`, nunca `dfp-*`
          (bloqueador de anúncios, ver `app-dfp-panel`).
        -->
          <div class="statement-modules" appStatementMasonry>
            <div
              id="statement-module-income"
              class="statement-module"
              [style.order]="modules.position('income')"
              [hidden]="!modules.isOn('income')">
              @if (modules.hasResizer('income')) {
                <app-statement-resizer [focusable]="modules.isFirstResizer('income')" />
              }
              <app-table-incomed-statement
                *ngIf="incomeStatementTableData.length"
                [collapsible]="tabs.is('financial-statements')"
                [collapseCommand]="tabs.collapseCommand()"
                [allowExport]="!readOnly()"
                [showAnalysisColumns]="showAnalysisColumns"
                [tableData]="incomeStatementTableData"
                [subAccountLines]="readOnly() ? null : subAccounts.income()"
                [companyName]="getSelectedCompanyName()"
                [availablePeriods]="availablePeriodsFor('income')"
                [hiddenYears]="dreHiddenYears"
                [requestedPeriods]="drePeriodColumns"
                [sourceDocuments]="sourceDocuments"
                [companyId]="selectedCompanyId"
                [valueScale]="valueScale"
                [reviewEnabled]="!readOnly()"
                (revenueOriginChanged)="onRevenueOriginChanged()"
                (periodAdd)="onPeriodAdd('income', $event)"
                (periodRemove)="onPeriodRemove('income', $event)"
                (yearReplace)="onYearReplace('income', $event)"
                (yearRemove)="onYearRemove('income', $event)"
                (yearRestore)="onYearRestore('income', $event)">
              </app-table-incomed-statement>
            </div>

            <div
              id="statement-module-balance"
              class="statement-module"
              [style.order]="modules.position('balance')"
              [hidden]="!modules.isOn('balance')">
              @if (modules.hasResizer('balance')) {
                <app-statement-resizer [focusable]="modules.isFirstResizer('balance')" />
              }
              <app-table-balance-sheet
                *ngIf="balanceSheetTableData.length"
                [collapsible]="tabs.is('financial-statements')"
                [collapseCommand]="tabs.collapseCommand()"
                [allowExport]="!readOnly()"
                [showAnalysisColumns]="showAnalysisColumns"
                [tableData]="balanceSheetTableData"
                [subAccountLines]="readOnly() ? null : subAccounts.balance()"
                [companyName]="getSelectedCompanyName()"
                [availablePeriods]="availablePeriodsFor('balance')"
                [hiddenYears]="balanceHiddenYears"
                [requestedPeriods]="balancePeriodColumns"
                [sourceDocuments]="sourceDocuments"
                [companyId]="selectedCompanyId"
                [valueScale]="valueScale"
                (periodAdd)="onPeriodAdd('balance', $event)"
                (periodRemove)="onPeriodRemove('balance', $event)"
                (yearReplace)="onYearReplace('balance', $event)"
                (yearRemove)="onYearRemove('balance', $event)"
                (yearRestore)="onYearRestore('balance', $event)">
              </app-table-balance-sheet>
            </div>

            <!-- DFC (PBI 3875): só na aba Demonstrativos, fora da barra "Mostrar". Cálculo do backend. -->
            <div
              id="statement-module-cashflow"
              class="statement-module"
              [style.order]="modules.position('cashflow')"
              [hidden]="!modules.isOn('cashflow')">
              @if (cashFlow.loaded() && !cashFlow.rows().length) {
                <app-simple-messages
                  text="Sem DFC para esta empresa. Ela sai da DRE e do Balanço validados e precisa de pelo menos dois anos de Balanço, porque compara cada ano com o anterior."
                  severity="info" />
              } @else if (cashFlow.rows().length) {
                <app-table-cash-flow
                  [allowExport]="!readOnly()"
                  [collapsible]="tabs.is('financial-statements')"
                  [collapseCommand]="tabs.collapseCommand()"
                  [tableData]="cashFlow.rows()"
                  [companyName]="getSelectedCompanyName()"
                  [valueScale]="valueScale" />
              }
            </div>

            <div
              id="statement-module-highlights"
              class="statement-module"
              [style.order]="modules.position('highlights')"
              [hidden]="!modules.isOn('highlights')">
              @if (modules.hasResizer('highlights')) {
                <app-statement-resizer [focusable]="modules.isFirstResizer('highlights')" />
              }
              @if (hasTableData && !highlightsTableData.length) {
                <app-simple-messages
                  text="Sem pontos de destaque para esta empresa. Eles saem da DRE e do Balanço padronizados; quando os dois estiverem validados, aparecem aqui."
                  severity="info" />
              }
              <!--
              Leitura do Cog (card 3801), projetada no topo do painel (`[panelLead]`): só para o time interno (o
              parceiro, no modo somente leitura, ainda não tem decisão). O `@if` tem um elemento só na raiz, então a
              projeção casa pelo atributo.
            -->
              <app-table-historical-highlights
                *ngIf="highlightsTableData.length"
                [allowExport]="!readOnly()"
                [tableData]="highlightsTableData"
                [companyName]="getSelectedCompanyName()"
                [availablePeriods]="availablePeriodsFor('highlights')"
                [hiddenYears]="highlightsHiddenYears"
                [requestedPeriods]="highlightsPeriodColumns"
                [sourceDocuments]="sourceDocuments"
                [companyId]="selectedCompanyId"
                [valueScale]="valueScale"
                (periodAdd)="onPeriodAdd('highlights', $event)"
                (periodRemove)="onPeriodRemove('highlights', $event)"
                (yearReplace)="onYearReplace('highlights', $event)"
                (yearRemove)="onYearRemove('highlights', $event)"
                (yearRestore)="onYearRestore('highlights', $event)">
                @if (!readOnly() && selectedCompanyId) {
                  <app-dfp-financial-reading panelLead [companyId]="selectedCompanyId" />
                }
              </app-table-historical-highlights>
            </div>

            <div
              id="statement-module-revenue"
              class="statement-module"
              [style.order]="modules.position('revenue')"
              [hidden]="!modules.isOn('revenue')">
              @if (modules.hasResizer('revenue')) {
                <app-statement-resizer [focusable]="modules.isFirstResizer('revenue')" />
              }
              @if (hasTableData && !revenueStatementTableData.length) {
                <app-simple-messages
                  text="Sem faturamento mensal para esta empresa. Envie a relação de faturamento ao Data Room e valide na Padronização para ele aparecer aqui."
                  severity="info" />
              }
              <app-table-revenue-statement
                *ngIf="revenueStatementTableData.length"
                [collapsible]="tabs.is('financial-statements')"
                [collapseCommand]="tabs.collapseCommand()"
                [allowExport]="!readOnly()"
                [tableData]="revenueStatementTableData"
                [companyName]="getSelectedCompanyName()"
                [valueScale]="valueScale"
                [originCompanyId]="readOnly() ? null : selectedCompanyId"
                (originChanged)="onRevenueOriginChanged()">
              </app-table-revenue-statement>
            </div>
          </div>

          <!-- Documentos de origem: largura total, embaixo da grade, seja qual for a combinação de módulos. -->
          <app-source-documents-panel
            *ngIf="!readOnly() && sourceDocuments && incomeStatementTableData.length"
            [documents]="sourceDocuments"
            (removeRequested)="onRemoveSourceDocument($event)"></app-source-documents-panel>
        </div>
      </ng-container>
    </div>
  </section>
}

<!--
  Modal "Ver De/Para" (PBI 3061): UMA instância para a tela inteira, pedida pelo menu de qualquer coluna de ano
  via `DfpStandardizationNavigationService`. `@defer (when …)` só cria a modal no primeiro pedido; depois
  disso ela fica montada e cada pedido novo a reabre.
-->
@defer (when deParaModalRequest) {
  <app-accounting-document-detail-modal
    [request]="deParaModalRequest"
    (closed)="onDeParaModalClosed($event)" />
}

<app-floating-ai-button
  *ngIf="selectedCompanyId && !readOnly()"
  [companyId]="selectedCompanyId"
  [defaultTab]="'financial'"></app-floating-ai-button>
